// eslint-disable-next-line no-unused-vars
const defaultToggles = {
  isVWOEnabled: false,
  payPalEnabled: true,
  minicartApplePayCtaEnabled: true,
  pdpPayPalCtaEnabled: true,
  cartPayPalCtaEnabled: true,

  applePayEnabled: true,
  miniCartApplePayCtaEnabled: true,
  pdpApplePayCtaEnabled: true,
  cartApplePayCtaEnabled: true,

  checkoutApplePayCtaEnabled: true,
  checkout_isBopusEnabled: false,
  sitewide_isContentfulEnabled: true,
  sitewide_isKustomerEnabled: true,
  showFreeShippingLabel: false,
  isSkipCartEnabled: false,
  isLoggingEnabled: true,
  isExtendWarrantyEnabled: true,
  isLoyaltyProgramEnabled: false,
  ltkPdpRecEnabled: true,
  collectionPdpEnabled: true,
  promoEnabled: false,
  isShippedShieldEnabled: true,
  isTurnToEnabled: true,
  isCSChatEnabled: true,
  isStripeApplePayEnabled: true,
  isStripePDPApplePayEnabled: true,
  isStripeCartApplePayEnabled: true,
  isStripeCheckoutApplePayEnabled: true,
  isStripeMiniCartApplePayEnabled: true,
  forceApplePayOn: false,
  isFreeShippingEnabled: true,
  isLinkEnabled: true,
  shouldShowBackorderBadge: false,
}
const manualEnvironmentOverrides = {
  local: {
    isVWOEnabled: true,
    sitewide_isKustomerEnabled: false,
    promoEnabled: true,
    isBloomreachEnabled: true,
  },
  staging: {
    isVWOEnabled: true,
    promoEnabled: true,
    isBloomreachEnabled: true,
  },
  production: {
    isVWOEnabled: true,
    isLoggingEnabled: false,
    ltkPdpRecEnabled: false,
    promoEnabled: true,
    isBloomreachEnabled: false,
    isTurnToEnabled: true,
    isCSChatEnabled: true,
  },
}

const setFeatureToggles = (environmentName) => (
  {
    ...defaultToggles,
    ...manualEnvironmentOverrides[environmentName],
  }
)

module.exports = setFeatureToggles
